<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_search') ||
                  '店铺名称/店铺账号/店铺ID/所属地区/申请公司/店长名字 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.listAmzStoreStatus">
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_valid') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('INDEX.form_label_invalid') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_amzStoreNo') || '店铺编号'">
              <el-input
                v-model="form.amzStoreNo"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_amzStoreName') || '店铺名称'">
              <el-input
                v-model="form.amzStoreName"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_amzStoreAccount') || '店铺账号'"
            >
              <el-input
                v-model="form.amzStoreAccount"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_amzStoreId') || '店铺ID'">
              <el-input
                v-model="form.amzStoreId"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
            >
              <dict-select
                v-model="form.amazonStoreRegion"
                url="/ecom/amz/market/dictSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item :label="$l('form_label_isOwnInv') || '是否自有库存'">
              <el-select
                v-model="form.listIsOwnInv"
                clearable
                filterable
                multiple
                size="mini"
                style="width:100%"
              >
                <el-option :label="'是'" value="Y"></el-option>
                <el-option :label="'否'" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_currency') || '交易币种'">
              <dict-select
                v-model="form.listCurrency"
                url="/master/common/dict/biz"
                :body="currencyUnitParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_region') || '所属国家'">
              <dict-select
                v-model="form.listRegionCode"
                url="/master/common/dict/biz"
                :body="regionParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_managerName') || '店长'">
              <dict-select
                v-model="form.listManagerCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                url="/master/common/dict/baseUserSelect"
                clearable
                filterable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_invStoreCode') || '售卖库存'">
              <dict-select
                v-model="form.listInvStoreCode"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                url="/ecom/amz/store/select"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_ecomCompanyName') || '申请公司'"
            >
              <dict-select
                v-model="form.listEcomCompanyCode"
                url="/ecom/ecomCompany/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_creditCardHolder') || '信用卡持卡人'"
            >
              <el-input
                v-model="form.creditCardHolder"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_creditCardNo') || '信用卡卡号'"
            >
              <el-input
                v-model="form.creditCardNo"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_expiryDate') || '信用卡到期年月'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.expiryYearMonthStart"
                    value-format="yyyy-MM"
                    type="month"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.expiryYearMonthEnd"
                    value-format="yyyy-MM"
                    type="month"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <!--  <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_loginMobile') || '登录手机号'">
              <el-input
                v-model="form.loginMobile"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_mobileOwnership') || '手机号归属'"
            >
              <el-input
                v-model="form.mobileOwnership"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_mobileProperties') || '手机性质'"
            >
              <el-input
                v-model="form.mobileProperties"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_mobileModel') || '手机品牌型号'"
            >
              <el-input
                v-model="form.mobileModel"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col> 
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_loginType') || '登录方式'">
              <el-input
                v-model="form.loginType"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_ipAddress') || 'IP地址'">
              <el-input
                v-model="form.ipAddress"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_ipCountry') || 'IP所属国家'">
              <el-input
                v-model="form.ipCountry"
                clearable
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '', listAmzStoreStatus: ['Y'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      regionParams: { dictType: 'region' },
      currencyUnitParams: { dictType: 'currencyUnit' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
